
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/addAd",
      function () {
        return require("private-next-pages/addAd.js");
      }
    ]);
  